import React, { InputHTMLAttributes } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegister,
} from "react-hook-form";
import FormError from "./FormError";
import IconTick from "@/components/icons/IconTick";

interface FormCheckboxType extends InputHTMLAttributes<any> {
  children?: any;
  register?: UseFormRegister<any>;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
}

export default function FormCheckbox({
  children,
  name,
  register,
  error,
  ...props
}: FormCheckboxType): React.ReactElement {
  return (
    <div>
      <label className="relative flex items-start">
        <div className="flex h-9 shrink-0 items-center">
          <div className="group relative size-9 min-h-9 min-w-9">
            <input
              type="checkbox"
              id={props.id || name}
              className="h-full w-full appearance-none rounded-lg border-2 border-gray-300 bg-white checked:border-[#34EEFF] checked:bg-[#34EEFF] indeterminate:border-[#34EEFF] indeterminate:bg-[#34EEFF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#34EEFF] disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
              {...props}
              {...(register ? register(name ?? "") : "")}
            />
            <IconTick
              className={
                "pointer-events-none absolute left-1/2 top-1/2 size-8 w-8 -translate-x-1/2 -translate-y-1/2 text-black group-has-[:disabled]:text-black/50"
              }
            />
          </div>
        </div>
        <div className="ml-5">
          <span className="text-[14px]/[22px]">{children}</span>
        </div>
      </label>
      <FormError error={error} />
    </div>
  );
}
